import { render, staticRenderFns } from "./NetaListMultiAttractionComponent.vue?vue&type=template&id=66a639dc&scoped=true&"
import script from "./NetaListMultiAttractionComponent.vue?vue&type=script&lang=js&"
export * from "./NetaListMultiAttractionComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaListMultiAttractionComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NetaListMultiAttractionComponent.vue?vue&type=style&index=1&id=66a639dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a639dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a639dc')) {
      api.createRecord('66a639dc', component.options)
    } else {
      api.reload('66a639dc', component.options)
    }
    module.hot.accept("./NetaListMultiAttractionComponent.vue?vue&type=template&id=66a639dc&scoped=true&", function () {
      api.rerender('66a639dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-list/NetaListMultiAttractionComponent.vue"
export default component.exports